// File: src/components/CookieBanner.js
import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";

const CookieBanner = () => {
  const [visible, setVisible] = useState(!Cookies.get("zoteya_cookie_consent"));

  const acceptCookies = () => {
    Cookies.set("zoteya_cookie_consent", "yes", { expires: 365 });
    setVisible(false);
  };

  useEffect(() => {
    if (Cookies.get("zoteya_cookie_consent")) setVisible(false);
  }, []);

  if (!visible) return null;

  return (
    <div
      style={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 99,
        background: "linear-gradient(90deg, #ede3c9 75%, #cab27c 100%)",
        color: "#433e3a",
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "center",
        padding: "19px 10px",
        boxShadow: "0 -5px 28px #cbb99133",
        fontSize: "1rem"
      }}
      role="region"
      aria-label="Cookie consent banner"
    >
      <span style={{
        marginRight: 18,
        lineHeight: "1.55",
        fontFamily: "Inter,sans-serif"
      }}>
        We use cookies to enhance your experience at Zoteya Salon.
        By continuing, you agree to our{" "}
        <a
          href="/cookies"
          style={{
            color: "#b49132",
            fontWeight: 600,
            textDecoration: "underline"
          }}
        >
          Cookies Policy
        </a>.
      </span>
      <button
        onClick={acceptCookies}
        className="btn fw-bold rounded-pill ms-2"
        style={{
          background: "linear-gradient(90deg,#c4a15a,#d4c4a8)",
          color: "#2d2d2d",
          fontSize: "1rem",
          border: "none",
          padding: "9px 28px",
          minWidth: 120,
          boxShadow: "0 2px 10px #e3d3a620",
          cursor: "pointer"
        }}
        aria-label="Accept cookies"
      >
        Accept
      </button>
    </div>
  );
};

export default CookieBanner;
